module.exports = __webpack_public_path__ + "img/mail_envoi_carte_tp.15ffe9ed.svg";